import React, { FC, memo, ComponentType, NamedExoticComponent } from "react";

import { Portal } from "@swiggy-private/dls-web-core/dist/components/Portal";
import { Overlay } from "../overlay";
import { OverflowHidden } from "../side-effects";

import styles from "./DialogHOC.scss";
import { withStyles } from "@core-ui/helpers/WithStyles";
import useFocusTrap from "@core-ui/hooks/UseFocusTrap";
import classNames from "classnames";

interface DialogHOCProps {
    closeModal: VoidFunction;
}

export default function DialogHOC<T extends object>(PassedComponent: ComponentType<T>): NamedExoticComponent<T> {
    const DialogWrappedComponent: FC<T> = (props: T) => {
        useFocusTrap();
        return (
            <Portal>
                <OverflowHidden>
                    <>
                        <div
                            className={classNames(styles.container, {
                                [styles.containerUx4]: true,
                            })}
                        >
                            <PassedComponent {...props} />
                        </div>
                        <Overlay onClick={(props as unknown as DialogHOCProps)?.closeModal} />
                    </>
                </OverflowHidden>
            </Portal>
        );
    };

    return memo(withStyles(DialogWrappedComponent, styles));
}
